import API from "./API";

export default {

   logIn: async( dto: LogInDTO ) => {
      const { data } = await API.post<AuthTokenResponse>( "/login", dto );
      return data;
   },

   logOut: () => API.post( "/logout" ),

   me: async() => {
      const { data } = await API.get<AuthUser>( "/user" );
      return data;
   },

   changePassword: ( dto: ChangePasswordDTO ) => API.post( "/user/change-password", dto ),

   forgotPassword: ( email: string ) => API.post( "/password/reset", { email }),

   resetPassword: ( dto: ResetPasswordDTO ) => API.post( "/password/update", dto )
}